export var errorMessage = {
  heading: "Something happened",
  description: "We are really sorry. There was an error processing your submission. Try reloading your browser, and submitting again."
};